import React, { useState } from 'react';

export default function ApiKeyModal({ onConfirm, onCancel }) {
  const [key, setKey] = useState(localStorage.getItem('sentinel_api_key') || '');
  const [err, setErr] = useState('');

  const confirm = () => {
    const k = key.trim();
    if (!k.startsWith('sk-ant-')) { setErr('Key must start with sk-ant-'); return; }
    localStorage.setItem('sentinel_api_key', k);
    onConfirm(k);
  };

  const overlay = {
    position: 'fixed', inset: 0, background: 'rgba(6,6,14,.88)',
    backdropFilter: 'blur(14px)', display: 'flex', alignItems: 'center',
    justifyContent: 'center', zIndex: 9000, padding: 24
  };
  const modal = {
    background: 'var(--card)', border: '1px solid var(--borderacc)',
    borderRadius: 28, padding: '44px 40px', maxWidth: 460, width: '100%',
    boxShadow: '0 0 80px rgba(124,58,237,.25)', animation: 'fadeUp .2s ease'
  };

  return (
    <div style={overlay} onClick={e => e.target === e.currentTarget && onCancel()}>
      <div style={modal}>
        <div style={{ fontFamily: 'var(--ff-display)', fontSize: 28, fontWeight: 800, letterSpacing: '-0.03em', marginBottom: 8 }}>
          Your API Key
        </div>
        <p style={{ fontSize: 14, color: 'var(--txt2)', lineHeight: 1.65, marginBottom: 28 }}>
          SentinelAI uses your Anthropic key directly — we never store it on our servers.
          Get one free at{' '}
          <a href="https://console.anthropic.com" target="_blank" rel="noreferrer"
            style={{ color: 'var(--violetbr)', textDecoration: 'none' }}>
            console.anthropic.com
          </a>
        </p>

        <label style={{ display: 'block', fontFamily: 'var(--ff-mono)', fontSize: 11, color: 'var(--violetbr)', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 8 }}>
          Anthropic API Key (BYOK)
        </label>
        <input
          type="password"
          placeholder="sk-ant-api03-..."
          value={key}
          onChange={e => { setKey(e.target.value); setErr(''); }}
          onKeyDown={e => e.key === 'Enter' && confirm()}
          autoFocus
          style={{
            width: '100%', background: 'var(--surface)', border: '1px solid rgba(255,255,255,.12)',
            borderRadius: 12, padding: '13px 16px', fontFamily: 'var(--ff-mono)',
            fontSize: 14, color: 'var(--txt)', outline: 'none',
            transition: 'border-color .2s'
          }}
          onFocus={e => { e.target.style.borderColor = 'var(--violetbr)'; }}
          onBlur={e => { e.target.style.borderColor = 'rgba(255,255,255,.12)'; }}
        />
        {err && <div style={{ marginTop: 8, fontSize: 12, color: 'var(--rose)', fontFamily: 'var(--ff-mono)' }}>⚠ {err}</div>}

        <div style={{ marginTop: 12, padding: '12px 14px', background: 'rgba(6,182,212,.08)', border: '1px solid rgba(6,182,212,.2)', borderRadius: 8, fontSize: 12, color: 'var(--cyan)', lineHeight: 1.55 }}>
          🔒 Your key is forwarded directly to Anthropic's API and saved only in localStorage. SentinelAI never logs it.
        </div>

        <div style={{ display: 'flex', gap: 12, marginTop: 28 }}>
          <button onClick={onCancel} style={{ flex: 1, padding: '13px', borderRadius: 12, background: 'transparent', border: '1px solid rgba(255,255,255,.12)', color: 'var(--txt2)', fontSize: 14, fontWeight: 600, transition: 'border-color .2s' }}
            onMouseEnter={e => { e.target.style.borderColor = 'var(--borderacc)'; }}
            onMouseLeave={e => { e.target.style.borderColor = 'rgba(255,255,255,.12)'; }}>
            Cancel
          </button>
          <button onClick={confirm} disabled={!key} style={{ flex: 1, padding: '13px', borderRadius: 12, background: key ? 'linear-gradient(135deg,var(--violet),#6d28d9)' : 'var(--surface)', border: 'none', color: '#fff', fontFamily: 'var(--ff-display)', fontSize: 15, fontWeight: 800, letterSpacing: '-0.02em', opacity: key ? 1 : .5, boxShadow: key ? '0 0 20px rgba(124,58,237,.4)' : 'none', transition: 'all .2s' }}>
            Continue →
          </button>
        </div>
      </div>
    </div>
  );
}
